<style scoped  lang="less">
.timeBox{
  .click{position: absolute;left: 0;top:0;width: 100%;height: 100%;overflow: hidden;z-index: 9999;}
  overflow: hidden;position: relative;
  height: 100%; width: 100%;
  .el-dateTile{opacity: 0 !important;width: 100%;height: 100%;z-index: 1; }
  .p_time{white-space: nowrap;}
  .pc_box{position: absolute;left: 0;top:0;width: 100%;height: 100%;}
}

</style>
<template>
  <div>

    <!-- v-if="(screenWidth>750?true:false)" -->
    <div class="timeBox">
        <div class="click" @click="openTimePicker"></div>
        <p class="p_time">{{dataTime}}</p>
        <div class="pc_box">
          <!-- @pick="handleTimePick"    :align="" -->
          <el-date-picker
            class="el-dateTile"
            v-model="pickedTime"
            type="date"  
            ref="timePicker" 
            :picker-options="pickerOptions"
            @change="onTimeConfirm" 
          ></el-date-picker>
        </div>
        <div class="web_box" >
        </div>
    </div>
    
    <van-popup v-model="show" position="bottom"> 
      <van-datetime-picker 
        v-model="pickedTime" 
        type="date" 
        :min-date="pickerOptions.minDate"
        :max-date="pickerOptions.maxDate"
        @confirm="onTimeConfirm" 
        @cancel="onTimeCancel" 
        :confirm-button-text="this.langConfig.txtLang[this.langConfig.curLang]['CONFIRM']"
        :cancel-button-text="this.langConfig.txtLang[this.langConfig.curLang]['CANCEL']"
      />
           
    </van-popup>

  </div>
</template>

<script>
export default {
  data() {
    return {
      pickedTime: "",
      dataTime: "",
      show: false,
      langTetx:{
        'zh-CN':{
          week:{0:'日',1:'一',2:'二',3:'三',4:'四',5:'五',6:'六'},
          today:'今天'
        },
        'en-US':{
          week:{0:'Sun',1:'Mon',2:'Tue',3:'Wed',4:'Thu',5:'Fri',6:'Sat'},
          today:'Today'
        },
      },
      
      pickerOptions: {}
    };
  },

  watch: {
    today(newValue) {
      console.log('todaytodaytodaytoday.',newValue);
      this.pickerOptions=this.getPickerOptions();
      this.setTime(this.today);
    }
  },
  methods: { 
    getPickerOptions(){
      var minDate=this.minDate;
      if(this.isPositiveOrNegativeNumber(minDate)){
        var minDateDay=this.getPickerDate(this.getAdjacentDate(this.getPickerDate().dayData,minDate*1));
      }else{
        var minDateDay=this.getPickerDate(new Date(minDate));
      } 
      var maxDate=this.maxDate;
      if(this.isPositiveOrNegativeNumber(maxDate)){
        var maxDateDay=this.getPickerDate(this.getAdjacentDate(this.getPickerDate().dayData,maxDate*1));
      }else{
        var maxDateDay=this.getPickerDate(maxDate);
      } 
      let today=(this.today?this.today:'');
      let lang=this.lang;
      let langTetx=this.langTetx; 
    //  console.log('lang22222',lang);
    //  console.log('lang2222222222',today);
    //  console.log('minDateDay',minDateDay);
    //  console.log('maxDateDay',maxDateDay);
      var shortcuts=[{
            text: this.langConfig.txtLang[this.langConfig.curLang]['DAY_WEEK_SORT'][7],
            onClick(picker) {
              picker.$emit('pick', (today?new Date(today):new Date()));
            }
          }
      ];
      //console.log('this.showToday',this.showToday);
      if(!this.showToday){
        shortcuts=null
      }
      return {
        disabledDate(time) {
          // 设置最小日期，禁止选择今天之前的日期
         // //console.log('time.getTime()',time.getTime());
          var minDay=time.getTime() <= new Date(minDateDay.dayData)- 8.64e7;
          var maxDay=time.getTime() >= new Date(maxDateDay.dayData)//maxDateDay.dayData
          return (minDay||maxDay);
        },
        shortcuts:shortcuts ,
        minDate:new Date(minDateDay.year*1, minDateDay.month*1-1, minDateDay.day*1),
        maxDate:new Date(maxDateDay.year*1, maxDateDay.month*1-1, maxDateDay.day*1),
        
      }
    },
    //获取日期格式   2008-1-1
    getPickerDate(val){
      //console.log('getCurrentDate',val);
      var _this=this;
      let today=new Date();
      if(this.today){
        today=new Date(this.today);
      }
      let currentDate = (val?new Date(val):today);
      let year = currentDate.getFullYear()+'';
      let month = (currentDate.getMonth() + 1)+''; // 加1以得到实际月份
      let day = currentDate.getDate()+'';
      let H = currentDate.getHours()+'';
      let  M = currentDate.getMinutes()+'';
      let  S = currentDate.getSeconds()+'';
      let  ww=currentDate.getDay()+'';  
      var objTime={
        year: year,
          month: (month<10?'0'+''+month:month),
          day:  (day<10?'0'+''+day:day),
          hour:(H<10?'0'+''+H:H),
          minutes:(M<10?'0'+''+M:M),
          seconds:(S<10?'0'+''+S:S),
          dayData:year+'-'+(month<10?'0'+''+month:month)+'-'+(day<10?'0'+''+day:day)
      }
      return objTime;
    },
    //获取日期格式   2008-1-1
    getCurrentDate(val,type){
      //console.log('getCurrentDate',val);
      var _this=this;
      let currentDate = (val?new Date(val):new Date());
      let year = currentDate.getFullYear()+'';
      let month = (currentDate.getMonth() + 1)+''; // 加1以得到实际月份
      let day = currentDate.getDate()+'';
      let H = currentDate.getHours()+'';
      let  M = currentDate.getMinutes()+'';
      let  S = currentDate.getSeconds()+'';
      let  ww=currentDate.getDay()+'';  
      //en-US
      let langTetx=this.langTetx;
      let lang=this.lang;
      var format=JSON.parse(JSON.stringify(_this.format));
      //console.log('format',_this.format,year,langTetx[lang]['week'][ww]);
      format=format.replace(/YYYY|yyyy/g, year)
          .replace(/YY|yy/g, year.substr(2, 2))
          .replace(/MM/g, (month < 10 ? '0' : '') + month)
          .replace(/DD/g, (day < 10 ? '0' : '') + day)
          .replace(/HH|hh/g, (H < 10 ? '0' : '') + H)
          .replace(/mm/g, (M < 10 ? '0' : '') + M)
          .replace(/ss/g, (S < 10 ? '0' : '') + S)
          .replace(/ww|WW/g, this.langConfig.txtLang[this.langConfig.curLang]['DAY_WEEK_SORT'][ww])

      //console.log('format2',format);
      return {
          year: year,
          month: (month<10?'0'+''+month:month),
          day:  (day<10?'0'+''+day:day),
          hour:(H<10?'0'+''+H:H),
          minutes:(M<10?'0'+''+M:M),
          seconds:(S<10?'0'+''+S:S),
          weekTetx:this.langConfig.txtLang[this.langConfig.curLang]['DAY_WEEK_SORT'][ww],
          weekDay:ww,
          lang:lang,
          date:format,
          dayData:year+'-'+(month<10?'0'+''+month:month)+'-'+(day<10?'0'+''+day:day)
      };
    },
    //打开时间选择
    openTimePicker() {
      // 打开时间选择器
      if(this.screenWidth>750){//PC
        this.show = false; 
        if(this.$refs.timePicker){
          this.$refs.timePicker.pickerVisible = true;
        }
      }else{//web
        if(this.$refs.timePicker){
          this.$refs.timePicker.pickerVisible = false;
        }
        this.show = true;
      }
    },
    //时间选择回调
    onTimeConfirm(value) {
        this.setTime(value);
        this.show = false;
        this.$emit('changeTime',this.getTime())
    },
    //时间变化回调
    onTimeChange(e) {
        let that = this
        this.show = false;
    },
    //关闭回调
    onTimeCancel() {
        this.show = false;
    },
    //获取屏幕宽度
    handleResize() {
      if(typeof window!='undefined'){
        this.screenWidth = window.innerWidth;
      }
    },
    getAdjacentDate(day,offset){
      var today = (day?new Date(day):new Date());
      var adjacentDate = new Date(today);
      adjacentDate.setDate(today.getDate() + offset);
      // 处理时间格式，确保月份和日期是两位数
      var formattedDate = adjacentDate.getFullYear() + '-' + 
                          ('0' + (adjacentDate.getMonth() + 1)).slice(-2) + '-' +
                          ('0' + adjacentDate.getDate()).slice(-2);

      return formattedDate;
    },
    isPositiveOrNegativeNumber(str){
        if (/^-?\d+(\.\d+)?$/.test(str)) {
          if (parseFloat(str) > 0) {
            return true;
          } else if (parseFloat(str) < 0) {
            return true;
          } else {
            return true;
          }
        } else {
          return false;
        }
    }, 
    //设置时间   
    setTime(val){
      if(val==undefined){
        var time=this.getCurrentDate();
      }else if(this.isPositiveOrNegativeNumber(val)){
        var time=this.getCurrentDate(this.getAdjacentDate(this.getTime(),val));
      }else{
        var time=this.getCurrentDate(val);
      } 

      let timeData=time.year+'-'+time.month+'-'+time.day;
      this.pickedTime=new Date(timeData);
      this.pickedTimeVal=timeData+'';
      this.dataTime=time.date+'';
      //this.dataTime=time.day+'/'+time.month+'/'+time.year;
      //console.log('timeData',timeData);
      //console.log('time',time);
      return timeData;
    },
    //获取时间
    getTime(val){ 
      return this.pickedTimeVal;
    }
  },
  created() {
    // 初始化
    if(typeof window!='undefined'){
      this.screenWidth = window.innerWidth;
    }
    this.pickerOptions=this.getPickerOptions();
    this.setTime(this.today);
  
  },
  mounted() {
    if(typeof window!='undefined'){
      window.addEventListener('resize', this.handleResize);
    }
  },
  beforeDestroy() {
    if(typeof window!='undefined'){
      window.removeEventListener('resize', this.handleResize);
    }
  },
  props: {
    format: {
      type: String,
      default:'DD/MM/YYYY WW'
    },
    lang: {
      type: String,
      default:'en-US'
    },
    minDate:{
      type: String,
      default:'2000-01-01'
    },
    maxDate:{
      type: String,
      default:'2100-12-31'
    },
    showToday:{
      type: Boolean,
      default:false
    },
    today:{
      type: String,
      required: false
    },
  },
};
</script>



// WEBPACK FOOTER //
// ./src/components/baseDatetime.vue